"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SvgSearch = void 0;

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.207 11.227L9.884 8.812c1.574-2.45.94-5.761-1.415-7.397C6.114-.221 2.929.438 1.356 2.887c-1.573 2.45-.94 5.76 1.416 7.397a4.965 4.965 0 0 0 5.698-.001l2.323 2.415a.985.985 0 0 0 1.414 0 1.07 1.07 0 0 0 0-1.47zM5.625 2.083c2.002 0 3.625 1.687 3.625 3.77 0 2.082-1.623 3.77-3.625 3.77S2 7.935 2 5.853c.002-2.082 1.624-3.768 3.625-3.77z"
  }));
};

exports.SvgSearch = SvgSearch;
var _default = SvgSearch;
exports.default = _default;